import { SmartTable } from '../../../../components/smart-table/smart-table.model';
import { passwordGrade } from '../../../../../util/password-strength';

export class Controller {

    /** @ngInject */
    constructor(
        $state, ImportSharedAuthenticatorsModal, ImportSharedPasswordsModal
    ) {
        this.ImportSharedAuthenticatorsModal = ImportSharedAuthenticatorsModal;
        this.ImportSharedPasswordsModal = ImportSharedPasswordsModal;
        this.$state = $state;
		this.stAdd2fa= new SmartTable();
        this.stWeaks = new SmartTable();
        this.stDuplicates = new SmartTable();
        // this.stWulnerables = new SmartTable();
    }

    $onInit() {
        this.add2faAccounts = this.accounts.filter(account => account.publicService.slug !== 'other' && !account.enabled2fa && account.publicService.support2fa);
        this.weakAccounts = this.accounts.filter(account => passwordGrade(account.password) < 3);
        this.authenticatorsCount = this.accounts.filter(account => account.enabled2fa).length;
        this.passwordManagersCount = this.accounts.length - this.authenticatorsCount;
        let passwords = this.accounts.filter(account => account.password && account.password.length > 0).map(item => { return item.password});
        this.duplicateAccounts = this.accounts.filter(account => this.getOccurrence(passwords, account.password) > 1)
        .sort((a, b) => a.password.localeCompare(b.password));
    }

    reload() {
        return this.$state.go('.', {}, {reload: '.'});
    }

    showImportPasswordModal() {
        return this.ImportSharedPasswordsModal().then(() => {
            return this.$state.go('company.sharing-center.shared-passwords');
        });
    }

    showImportAuthenticatorModal() {
        return this.ImportSharedAuthenticatorsModal().then(() => {
            return this.$state.go('company.sharing-center.shared-authenticators');
        });
    }

    getOccurrence(array, value) {
        return array.filter((v) => (v === value)).length;
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/security-scan/security-scan.controller.js